module.exports = __webpack_public_path__ + "img-dashboard/register/upload-photo-ilustration.18314f1f.png";